import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-c-small', 'LetterCSmall', [["path",{"d":"M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"}]]);